// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"7b900cf0","443":"988c1e08","677":"e93dac75","819":"1e53ad01"}[chunkId] + ".chunk.js";
};